module.exports = __webpack_public_path__ + "static/media/twitter-circle.83a90e6c.svg";